import { Users, Shield, UserCheck } from "lucide-react"

interface AdminStatsProps {
  totalAdmins: number
  activeAdmins: number
  totalRoles: number
}

export function AdminStats({ totalAdmins, activeAdmins, totalRoles }: AdminStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-blue-100 rounded-lg text-secondary">
          <Users className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Total Admins</p>
          <h3 className="text-2xl font-bold text-foreground">{totalAdmins}</h3>
        </div>
      </div>

      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-teal-100 rounded-lg text-primary">
          <UserCheck className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Active Admins</p>
          <h3 className="text-2xl font-bold text-foreground">{activeAdmins}</h3>
        </div>
      </div>

      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-purple-100 rounded-lg text-purple-600">
          <Shield className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Total Roles</p>
          <h3 className="text-2xl font-bold text-foreground">{totalRoles}</h3>
        </div>
      </div>
    </div>
  )
}
